import React, { useMemo, useState } from "react";
import { Icon } from "@/components/ui";

const WEEKDAYS = ["S", "M", "T", "W", "T", "F", "S"];
export const TIME_SLOTS = ["07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00"];
export const toYMD = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const fmtTime = (t) => { const [h, m] = t.split(":").map(Number); return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`; };

export function DatePicker({ value, onChange, minDate, testID }) {
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const min = minDate ? new Date(minDate) : today; min.setHours(0, 0, 0, 0);
  const valid = value && /^\d{4}-\d{2}-\d{2}$/.test(value) ? value : null;
  const initial = valid ? new Date(valid + "T00:00:00") : min;
  const [cursor, setCursor] = useState(new Date(initial.getFullYear(), initial.getMonth(), 1));

  const cells = useMemo(() => {
    const first = new Date(cursor.getFullYear(), cursor.getMonth(), 1);
    const days = new Date(cursor.getFullYear(), cursor.getMonth() + 1, 0).getDate();
    const out = Array(first.getDay()).fill(null);
    for (let d = 1; d <= days; d++) out.push(new Date(cursor.getFullYear(), cursor.getMonth(), d));
    while (out.length % 7) out.push(null);
    return out;
  }, [cursor]);

  const canPrev = new Date(cursor.getFullYear(), cursor.getMonth() + 1, 0) > min;
  const monthLabel = cursor.toLocaleDateString([], { month: "long", year: "numeric" });

  return (
    <div className="dp" data-testid={testID}>
      <div className="dp-head">
        <button className="dp-nav" data-testid={testID ? `${testID}-prev` : undefined} disabled={!canPrev}
          onClick={() => setCursor(new Date(cursor.getFullYear(), cursor.getMonth() - 1, 1))}><Icon name="chevron-left" size={20} /></button>
        <span className="dp-month">{monthLabel}</span>
        <button className="dp-nav" data-testid={testID ? `${testID}-next` : undefined}
          onClick={() => setCursor(new Date(cursor.getFullYear(), cursor.getMonth() + 1, 1))}><Icon name="chevron-right" size={20} /></button>
      </div>
      <div className="dp-grid">{WEEKDAYS.map((w, i) => <div key={i} className="dp-wd">{w}</div>)}</div>
      <div className="dp-grid">
        {cells.map((d, i) => {
          if (!d) return <div key={i} />;
          const ymd = toYMD(d); const disabled = d < min; const sel = valid === ymd; const isToday = d.getTime() === today.getTime();
          return (
            <button key={i} type="button" data-testid={testID ? `${testID}-day-${ymd}` : undefined} disabled={disabled}
              className={`dp-cell${sel ? " selected" : ""}${isToday && !sel ? " today" : ""}`} onClick={() => onChange(ymd)}>{d.getDate()}</button>
          );
        })}
      </div>
    </div>
  );
}

export function TimePicker({ value, onChange, testID }) {
  return (
    <div className="time-slots" data-testid={testID}>
      {TIME_SLOTS.map((t) => (
        <button key={t} type="button" data-testid={testID ? `${testID}-${t}` : undefined}
          className={`time-slot${value === t ? " selected" : ""}`} onClick={() => onChange(t)}>{fmtTime(t)}</button>
      ))}
    </div>
  );
}
